
import { createApp, reactive } from 'vue';
import loadingComponent from './loading.vue';
import {fnColorLog} from '@activity-business/h5-package-frameworkTool';

let root: HTMLDivElement = document.createElement('div');
    document.body.appendChild(root);

let defaultConfig = {
    visible: false,
};
let loadingStackArr: string[] = [];
let callNum = 0;
let reactiveDefaultConfig = reactive(defaultConfig);
//  通过 props 注入 {visible: boolean} 控制显示隐藏数据
createApp(loadingComponent, {config: reactiveDefaultConfig}).mount(root);

// 通过 inject 不传参直接调用默认显示 loading
let provideFunc: (isDebugger: boolean, moduleVersion?: string)=> (visible : boolean)=> void = (isDebugger, moduleVersion) =>{
    return (visible = true)=> {
        // 第一版
        if(moduleVersion === 'v1.0.0'){
            reactiveDefaultConfig.visible = visible;
        }
        // 最新版
        if(moduleVersion === undefined){
            // loading 调用栈
            if(isDebugger && ENV !== 'build'){
                try {
                    let errPosition = String(new Error().stack || 'No Stack!').split('\n')[2];
                    // let info = `Visible: ${visible}, \nPosition:${ errPosition.replace(/[\w|\s]*(?=\$)/g, '') }`;
                    let callInfo = `Visible: ${visible}, \nPosition:${ errPosition.slice(errPosition.indexOf('(webpack')) }`;
                    loadingStackArr.push(callInfo);
                    fnColorLog('developTool_TS Loading stack debugger: ', 'info', loadingStackArr)
                } catch (error) {}
            }

            callNum = Math.max(visible ? ++callNum : --callNum, 0);
            reactiveDefaultConfig.visible = callNum > 0;
        }
    };
};

export default provideFunc
